import { apiFetch } from './client';

export const analyticsApi = {
  kpis: () => apiFetch('/api/analytics/kpis'),
  charts: () => apiFetch('/api/analytics/charts'),
  hourlyHeatmap: (params) => apiFetch('/api/analytics/hourly-heatmap', { params }),
  callFunnel: (params) => apiFetch('/api/analytics/call-funnel', { params }),
  latency: (params) => apiFetch('/api/analytics/latency-over-time', { params }),
  asr: (params) => apiFetch('/api/analytics/asr-performance', { params }),
  variants: (params) => apiFetch('/api/analytics/variant-comparison', { params }),
  sentimentTrend: (params) => apiFetch('/api/analytics/sentiment-trend', { params }),
  campaignLeaderboard: (params) => apiFetch('/api/analytics/campaign-leaderboard', { params }),
  intentSankey: (params) => apiFetch('/api/analytics/intent-sankey', { params }),
  conversationPath: (params) => apiFetch('/api/analytics/conversation-path', { params }),
  wordCloud: (params) => apiFetch('/api/analytics/word-cloud', { params }),
  timelineReplay: (params) => apiFetch('/api/analytics/timeline-replay', { params }),
  carrierQuality: (params) => apiFetch('/api/analytics/carrier-quality', { params }),
  dailyReport: () => apiFetch('/api/analytics/daily-report'),
  createPermalink: (body) => apiFetch('/api/analytics/permalink', { method: 'POST', body }),
};

export const insightsApi = {
  daily: () => apiFetch('/api/insights/daily'),
  forecast: (params) => apiFetch('/api/insights/v2/forecast', { params }),
  anomalies: (params) => apiFetch('/api/insights/v2/anomalies', { params }),
  intentTree: (params) => apiFetch('/api/insights/v2/intent-tree', { params }),
  keywordSentiment: (params) => apiFetch('/api/insights/v2/keyword-sentiment', { params }),
  scheduleRecommendations: () => apiFetch('/api/insights/v2/schedule-recommendations'),
  volumeBalance: () => apiFetch('/api/insights/v2/volume-balance'),
  topics: (params) => apiFetch('/api/insights/v2/topics', { params }),
};
